<div class="sidebar-header" [class.collapsed]="isCollapsed">
  <div class="logo-wrapper">
    <img
      class="logo-icon"
      src="assets/images/beExpert.svg"
      alt="BeExpert Logo"
    />
    <div class="logo-text-group" *ngIf="!isCollapsed">
      <span class="logo-title">BeExpert.ai</span>
      <span class="logo-subtitle">Proctoring console</span>
    </div>
  </div>
  <button class="collapse-toggle-btn" (click)="onToggleCollapse()">
    <svg
      *ngIf="!isCollapsed"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
    <svg
      *ngIf="isCollapsed"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>
</div>

<!-- Navigation List -->
<nav class="sidebar-nav">
  <ng-container *hasPermission="PermissionForStudents.PROCTORING_DASHBOARD">
  <a
    class="nav-item"
    [class.active]="activeTab === 'dashboard'"
    (click)="selectTab('dashboard')"
    title="Dashboard"
  >
    <svg
      class="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Dashboard</span>
  </a>
  </ng-container>

  <ng-container *hasPermission ="[ PermissionForStudents.PROCTORING_CONFIG ,PermissionForStudents.PROCTORING_RULESET]">
   <div class="nav-group">
    <a
      class="nav-item"
      [class.active]="
        activeTab === 'proto-rules' || activeTab === 'proto-configs'
      "
      (click)="toggleRuleMenu()"
      title="Rule Configuration"
    >
      <svg
        class="nav-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <rect width="20" height="14" x="2" y="7" rx="2"></rect>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
      </svg>

      <span class="nav-label" *ngIf="!isCollapsed"> RuleSets </span>

      <i
        *ngIf="!isCollapsed"
        class="bi"
        [ngClass]="showRuleMenu ? 'bi-chevron-down' : 'bi-chevron-right'"
      >
      </i>
    </a>

    <div class="submenu" *ngIf="showRuleMenu && !isCollapsed">
        
    <ng-container *hasPermission = "PermissionForStudents.PROCTORING_CONFIG">
      <a
        class="submenu-item"
        [class.active]="activeTab === 'proto-configs'"
        (click)="selectTab('proto-configs')"
      >
        Proctoring Configuration
      </a>
     </ng-container> 

      <ng-container *hasPermission = "PermissionForStudents.PROCTORING_RULESET">
      <a
        class="submenu-item"
        [class.active]="activeTab === 'proto-rules'"
        (click)="selectTab('proto-rules')"
      >
         Ruleset Configuration
      </a>
      </ng-container>
    </div>
  </div>
  </ng-container>

  <ng-container *hasPermission = "PermissionForStudents.PROCTORING_ASSESSMENT">
  <a
    class="nav-item"
    [class.active]="activeTab === 'proto-assessment'"
    (click)="selectTab('proto-assessment')"
    title="proto-assessment"
  >
    <svg
      class="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Assessments</span>
  </a> 
  </ng-container>
</nav>

<div class="sidebar-footer">
  <a class="nav-item logout-nav-item" (click)="onLogout()" title="Logout">
    <svg
      class="nav-icon logout-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
    <span class="nav-label" *ngIf="!isCollapsed">Logout</span>
  </a>
</div>
